import type { FC } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import ResetConfirmPageDesktop from 'src/components/account/PasswordResetConfirmPage/ResetConfirmPageDesktop';
import ResetConfirmPageMobile from 'src/components/account/PasswordResetConfirmPage/ResetConfirmPageMobile';

const PasswordResetConfirmPage: FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  return isDesktop ? <ResetConfirmPageDesktop /> : <ResetConfirmPageMobile />;
};

export default PasswordResetConfirmPage;
